import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {AppConfig} from '../shared/app-config';
import {environment} from '../../environments/environment';
import {ErrorDataService} from './error-data.service';
import {catchError, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TtsService {

  constructor(private httpClient: HttpClient) {
  }

  getTts(text: string, outputFormat: string, locale: string, voiceId?: string, textType = 'ssml', outputType = 'audio_stream'): Observable<Blob | HttpErrorResponse> {
    const urlService = AppConfig.urlTTS;
    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Accept', 'audio/mpeg');

    const bodyRequest = {
      source_app: AppConfig.ttsSourceApp,
      text: text,
      text_type: textType,
      output_format: outputFormat,
      output_type: outputType,
      locale: locale,
      voice_id: voiceId
    };
    return this.httpClient.post(environment.contentLibraryApiBaseUrl + urlService, bodyRequest,
      {responseType: 'blob', headers: headers}).pipe(
        catchError((err: Error | HttpErrorResponse) => {
      const message = `In TtsService.getTts(${locale},${outputFormat}). ${err.message}`;
      if (err instanceof HttpErrorResponse) {
        const $errBlobReader: Observable<HttpErrorResponse> = Observable.create((observer) => {
          const fr = new FileReader();
          const errorBlob = err.error;
          fr.readAsText(errorBlob, 'utf8');
          fr.onloadend = () => {
            const errMsg = JSON.parse(typeof fr.result === 'string' ? fr.result : '').message;
            const msg = `In TtsService.getTts(${locale},${outputFormat}). ${errMsg}`;
            observer.error(ErrorDataService.overLoadError(err, msg));
          };
          fr.onerror = (blobReadError) => {
            observer.error(blobReadError);
          };
          fr.onabort = () => {
            observer.error('aborted');
          };
        });
        return $errBlobReader;
      } else {
        return throwError(ErrorDataService.overLoadError(err, message));
      }
    }));
  }

}
